import { jsx as _jsx } from "react/jsx-runtime";
export const EmptyStateCell = () => {
  return /*#__PURE__*/_jsx("span", {
    children: "--"
  });
};